var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { css } from 'lit';
import { customElement } from 'lit/decorators.js';
import { EdgelessColorPanel } from './color-panel.js';
import { colorContainerStyles } from './color-panel.js';
let EdgelessOneRowColorPanel = class EdgelessOneRowColorPanel extends EdgelessColorPanel {
};
EdgelessOneRowColorPanel.styles = css `
    :host {
      display: flex;
      width: 442px;
      padding: 0 2px;
      gap: 18px;
      box-sizing: border-box;
      background: var(--affine-popover-background);
    }

    ${colorContainerStyles}
  `;
EdgelessOneRowColorPanel = __decorate([
    customElement('edgeless-one-row-color-panel')
], EdgelessOneRowColorPanel);
export { EdgelessOneRowColorPanel };
//# sourceMappingURL=one-row-color-panel.js.map